import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    PartyName: {
      validations: []
    },
    telnumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    email: {
      validations: [
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    plannedguestcount: {
      validations: []
    },
    sitename: {
      validations: []
    },
    theme: {
      validations: []
    },
    description: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Name:',
            mapping: 'PartyName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone:',
            mapping: 'telnumber'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Expected number of guests:',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Event Location (Optional):',
            mapping: 'sitename'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Occasion (Optional):',
            options: [
              { label: 'Anniversary', value: 'Anniversary' },
              { label: 'Baby Shower', value: 'Baby Shower' },
              { label: 'Birthday', value: 'Birthday' },
              { label: 'Business', value: 'Business' },
              { label: 'Christmas Party', value: 'Christmas Party' },
              { label: 'Fundraiser', value: 'Fundraiser' },
              { label: 'Graduation', value: 'Graduation' },
              { label: 'Holiday', value: 'Holiday' },
              { label: 'Memorial', value: 'Memorial' },
              { label: 'Other Event', value: 'Other Event' },
            ],
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Type (Optional):',
            options: [
              { label: 'Plated Meal', value: 'Plated Meal' },
              { label: 'Tasting', value: 'Tasting' },
              { label: 'Breakfast Buffet', value: 'Breakfast Buffet' },
              { label: 'Lunch Buffet', value: 'Lunch Buffet' },
              { label: 'Dinner Buffet', value: 'Dinner Buffet' },
              { label: 'Appetizer Buffet', value: 'Appetizer Buffet' },
              { label: 'Appetizers Served', value: 'Appetizers Served' },
              { label: 'Breakfast Dropped Off', value: 'Breakfast Dropped Off' },
              { label: 'Lunch Dropped Off', value: 'Lunch Dropped Off' },
              { label: 'Dinner Dropped Off', value: 'Dinner Dropped Off' },
              { label: 'Boxed Lunch Delivered', value: 'Boxed Lunch Delivered' },
            ],
            mapping: 'description'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Tell us about your vision (Optional):',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Happy Day Catering Contact Form',
    formId: '1885',
    clientKey: '643A10C7-8807-490B-B208-BB7E3EB56BC8',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
